// extracted by mini-css-extract-plugin
export default {"wrapper":"Profile_wrapper__2a4gg","contentWrapper":"Profile_contentWrapper__380_x","profileHeader":"Profile_profileHeader__2-Abv"};